import { ref } from 'vue';
const getTags = (posts) => {
  const tags = ref([]);
  const tagSet = new Set(); //一種型別，裡面的值不能重複
  posts.forEach((item) => {
    item.tags.forEach(tag => tagSet.add(tag)); //若是加入的值有重複就會自動忽略
  });
  tags.value = [...tagSet]; // has individual value in the array
  return { tags };
};

export default getTags;